import React, { useState, useEffect } from 'react';
import { Input, Spinner } from '../../../shared/components';
import useDebounce from '../../../shared/hooks/useDebounce';
import { useVisitRegistration } from '../hooks/useVisitRegistration';
//import './PatientSearch.css';

const PatientSearch = ({ onPatientSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [patients, setPatients] = useState([]);
  const [searching, setSearching] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const { searchPatients } = useVisitRegistration();

  useEffect(() => {
    const performSearch = async () => {
      if (debouncedSearchTerm.length < 3) {
        setPatients([]);
        return;
      }

      setSearching(true);
      try {
        const results = await searchPatients(debouncedSearchTerm);
        setPatients(results);
      } catch (error) {
        console.error('Patient search failed:', error);
        setPatients([]);
      } finally {
        setSearching(false);
      }
    };

    performSearch();
  }, [debouncedSearchTerm, searchPatients]);

  return (
    <div className="patient-search">
      <Input
        label="Search Patient"
        placeholder="Enter patient name, ID, or phone number (min. 3 characters)"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      
      {searching && (
        <div className="searching-indicator">
          <Spinner size="small" /> Searching...
        </div>
      )}
      
      {patients.length > 0 && (
        <div className="search-results">
          {patients.map((patient) => (
            <div
              key={patient.id}
              className="patient-result"
              onClick={() => onPatientSelect(patient)}
            >
              <div className="patient-name">{patient.full_name}</div>
              <div className="patient-details">
                <span>ID: {patient.patient_code}</span>
                <span>DOB: {patient.date_of_birth}</span>
                <span>Phone: {patient.mobile || patient.phone}</span>
              </div>
            </div>
          ))}
        </div>
      )}
      
      {searchTerm.length >= 3 && !searching && patients.length === 0 && (
        <div className="no-results">No patients found</div>
      )}
      
      <div className="quick-actions">
        <button className="btn-quick-register">
          Register New Patient
        </button>
      </div>
    </div>
  );
};

export default PatientSearch;